import Vue from 'vue'
import Toasted from 'vue-toasted'
import axios from '@/util/axios'
import PortalVue from 'portal-vue'
import Loading from '@/components/Loading'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(PortalVue)
Vue.use(VueFormWizard)
Vue.use(Vue2TouchEvents)

Vue.use(Toasted, {
    theme: 'california-electrical-training',
    position: 'bottom-right',
    duration: 6000,
})

export default class Website {

    constructor(config) {
        this.bus = new Vue()
        this.config = config

        moment.locale(config.locale);

        // Debug
        Vue.config.debug = config.debug;
        Vue.config.devtools = config.debug;
    }

    /**
     * Start the Nova app by calling each of the tool's callbacks and then creating
     * the underlying Vue instance.
     */
    liftOff() {
        let _this = this

        this.app = new Vue({
            el: '#california-electrical-training',
            components: { Loading },
            mounted: function () {
                this.$loading = this.$refs.loading
            },
            methods: {
                google() {
                    App.bus.$emit('google-api-ready')
                }
            }
        })
    }

    /**
     * Return an axios instance configured to make requests to Nova's API
     * and handle certain response codes.
     */
    request(options) {
        if (options !== undefined) {
            return axios(options)
        }

        return axios
    }

    /**
     * Register a listener on Nova's built-in event bus
     */
    $on(...args) {
        this.bus.$on(...args)
    }

    /**
     * Register a one-time listener on the event bus
     */
    $once(...args) {
        this.bus.$once(...args)
    }

    /**
     * Unregister an listener on the event bus
     */
    $off(...args) {
        this.bus.$off(...args)
    }

    /**
     * Emit an event on the event bus
     */
    $emit(...args) {
        this.bus.$emit(...args)
    }
    /**
     * Show an error message to the user.
     *
     * @param {string} message
     */
    error(message) {
        Vue.toasted.show(message, { type: 'error' })
    }

    /**
     * Show a success message to the user.
     *
     * @param {string} message
     */
    success(message) {
        Vue.toasted.show(message, { type: 'success' })
    }

    /**
     * Show a warning message to the user.
     *
     * @param {string} message
     */
    warning(message) {
        Vue.toasted.show(message, { type: 'warning' })
    }

    /**
     * Register a keyboard shortcut.
     */
    addShortcut(keys, callback) {
        Mousetrap.bind(keys, callback)
    }

    /**
     * Unbind a keyboard shortcut.
     */
    removeShortcut(keys) {
        Mousetrap.unbind(keys)
    }
}
